import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as moment from 'moment';
import 'moment/locale/pt-br';
import { IMyDpOptions } from 'mydatepicker';

export interface ExtensionModal {
	title: string;
	selectedBillings: any[];
	clientID: string;
}

@Component({
	selector: 'app-bc-extension-modal',
	templateUrl: './bc-extension-modal.component.html',
	styleUrls: ['./bc-extension-modal.component.scss'],
	providers: [
		BcAccountClientService
	]
})

export class BcExtensionModalComponent extends DialogComponent<ExtensionModal, boolean> implements ExtensionModal {

	title: string;
	selectedBillings: any[];
	clientID: string;

	isRestricted: boolean = false;
	NovoVencimento: any;
	total: number;
	permissoes: any[] = [];
	existsProposal: boolean = null;
	existsProposalID: string = "";

		//Option to datepicker
		private myDatePickerOptions: IMyDpOptions = {
			// other options...
			dayLabels:{su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
			monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
			dateFormat: 'dd/mm/yyyy',
			showTodayBtn: false,
			//disableSince: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
			//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
			//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
			//editableDateField: false,
			height: "30px"
		};

	constructor(private router: Router, private route: ActivatedRoute, dialogService: DialogService, private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService) {
		super(dialogService);
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		let sum = 0;

		for (var key in this.selectedBillings) {
			var obj = this.selectedBillings[key];
			
			sum += obj.ValorInterno;

			if (!obj.NaoCobranca)
				this.isRestricted = true;
		}
		
		this.total = sum;

		this.checkProposal();
	}

	action() {
		if (this.existsProposal) {
			this.addTitles();
		} else {
			this.sendExtensionProposal();
		}	
	}

	checkProposal() {
        this.bcAccountClientService.getBilllingInfos(this.clientID).subscribe(result => {
            if (result.Success) {
                if (result.Result.PropostaProrrogacaoID) {
					if (result.Result.PropostaProrrogacaoStatus === 'EC') {
						this.existsProposal = true;
						this.existsProposalID = result.Result.PropostaProrrogacaoID;
					} else {
						this.flashMessagesService.show("Só é possível adicionar títulos a uma proposta Em Criação", { cssClass: 'alert-danger', timeout: 6000 });
						this.close();
					}
				} else {
					this.existsProposal = false;
				} 
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

	sendExtensionProposal() {
		var obj = {
			NovoVencimento: this.NovoVencimento ? moment(this.NovoVencimento.jsdate).format("YYYY-MM-DD") : null,
			Titulos: this.selectedBillings,
			ContaClienteID: this.clientID
		}

		this.bcAccountClientService.sendExtensionProposal(obj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Solicitação de prorrogação realizada com sucesso ", { cssClass: 'alert-success', timeout: 6000 });
				this.result = true;
				this.close();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	addTitles() {

		var obj = {
			ID: this.existsProposalID,
			ContaClienteID: this.clientID,
			Titulos: this.selectedBillings,
			NovoVencimento: this.NovoVencimento ? moment(this.NovoVencimento.jsdate).format("YYYY-MM-DD") : null,
		}

		
		this.bcAccountClientService.addTitles(obj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Títulos adicionados com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				this.result = true
				this.close();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
		
	}

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-extension-modal/bc-extension-modal.component.ts